// extracted by mini-css-extract-plugin
export default {"container":"spiderChart_container__mX69j","title":"spiderChart_title__o6XYK","legend":"spiderChart_legend__lO-bK"};